import { render, staticRenderFns } from "./OrderConfirmationCard.vue?vue&type=template&id=159c2098&scoped=true"
import script from "./OrderConfirmationCard.vue?vue&type=script&lang=ts"
export * from "./OrderConfirmationCard.vue?vue&type=script&lang=ts"
import style0 from "./OrderConfirmationCard.vue?vue&type=style&index=0&id=159c2098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159c2098",
  null
  
)

export default component.exports